export const TOKEN_REFRESH_THRESHOLD_MINUTES = 30; // 30 minutes